var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapBigLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 167,
    viewBox: "0 0 174 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.736 166.473H86.8031C38.778 166.473 0 129.145 0 83.2366C0 60.2107 9.6945 39.473 25.504 24.3131C41.1644 9.29618 62.7906 0 86.8031 0C110.816 0 132.591 9.29618 148.102 24.3131C156.007 31.8931 162.271 40.9032 166.745 50.9145C171.22 60.7827 173.606 71.7951 173.606 83.3796C173.606 101.686 167.491 118.562 156.902 132.292C154.665 135.438 151.98 138.299 149.146 141.016L124.09 116.703C132.74 107.979 137.96 96.2513 137.96 83.2366C137.96 69.6499 132.293 57.4933 123.046 48.6262C113.799 39.7591 100.823 34.3244 86.8031 34.3244C72.7834 34.3244 59.9568 39.7591 50.7097 48.6262C41.4627 57.4933 35.7951 69.6499 35.7951 83.2366C35.7951 110.267 58.6145 132.149 86.8031 132.149V96.6803L159.736 166.473Z",
    fill: "url(#paint0_linear_1008_3682)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_3682",
    x1: 43.0109,
    y1: 167.896,
    x2: 156.289,
    y2: -16.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0394E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBigLogo);
export default __webpack_public_path__ + "static/media/roadmap_big_logo.ae8584bda6ea06a870d9ba85a67d02be.svg";
export { ForwardRef as ReactComponent };